module.exports = __webpack_public_path__ + "img/empty_tips.3807378a.png";